module.exports = __webpack_public_path__ + "img/成都办公室.6339e65a.jpg";